import axios, {AxiosRequestConfig} from "axios";
import {api_host} from "../utils/constants";
import {configDefault} from "./post";

function patch<ResponseType = any>(
  url: string,
  data: any,
  cfg?: AxiosRequestConfig
) {
  return axios.patch<ResponseType>(api_host + '/' + url, data, {...configDefault(), ...cfg});
}

export default patch;